(() => {
  if (window.PPCollectionLoading) return;
  const checkoutIntent = '.m-cart-icon-bubble, .shiprocket-headless, [name="add"], [name="checkout"]';

  function warmCheckout() {
    if (navigator.connection?.saveData || document.getElementById('fastrr-prefetch-container')) return;
    const container = document.createElement('div');
    container.id = 'fastrr-prefetch-container';
    container.hidden = true;
    const iframe = document.createElement('iframe');
    iframe.id = 'prefetch-iframe';
    iframe.title = 'Checkout preparation';
    iframe.tabIndex = -1;
    const url = new URL(window.checkoutBuyer || 'https://fastrr-boost-ui.pickrr.com/');
    url.searchParams.set('prefetch', 'true');
    iframe.src = url.href;
    container.append(iframe);
    document.body.append(container);
  }

  function revealHoverImage(target) {
    const card = target.closest?.('[data-product-container] .m-product-card');
    const template = card?.querySelector('template[data-pp-collection-hover]');
    if (!template) return;
    template.replaceWith(template.content.cloneNode(true));
  }

  function prepareCheckout(event) {
    if (event.target.closest?.(checkoutIntent)) warmCheckout();
  }

  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    revealHoverImage(event.target);
    prepareCheckout(event);
  }, { passive: true });
  document.addEventListener('focusin', event => {
    revealHoverImage(event.target);
    prepareCheckout(event);
  });
  document.addEventListener('pointerdown', prepareCheckout, { passive: true });

  function ready() {
    const drawer = document.querySelector('m-cart-drawer');
    if (!drawer) return;
    const onOpen = () => {
      if (drawer.classList.contains('m-cart-drawer--active')) warmCheckout();
    };
    new MutationObserver(onOpen).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    onOpen();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  window.PPCollectionLoading = { warmCheckout, revealHoverImage };
})();
